var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#apple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.49 6.477c-.113.086-2.126 1.182-2.126 3.62 0 2.82 2.561 3.817 2.638 3.841-.012.061-.407 1.367-1.35 2.696-.842 1.17-1.72 2.34-3.057 2.34s-1.68-.751-3.224-.751c-1.503 0-2.038.775-3.26.775-1.223 0-2.076-1.083-3.057-2.413C.918 15.023 0 12.597 0 10.295 0 6.6 2.485 4.641 4.93 4.641c1.299 0 2.382.824 3.198.824.776 0 1.987-.874 3.465-.874.56 0 2.573.05 3.898 1.885ZM10.892 3.03c.612-.701 1.044-1.674 1.044-2.647 0-.135-.012-.272-.037-.382-.995.036-2.178.64-2.892 1.44-.56.616-1.083 1.589-1.083 2.575 0 .148.026.296.038.344.063.011.165.024.267.024.892 0 2.015-.577 2.663-1.354Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v19H0z"
  })))));
};
export default SvgApple;